import { Stack, Typography } from '@mui/material';
import { formatDate, formatTime } from 'legacyfrontend/utils/dateUtils';
import formatSecondsToHours, {
  getTimeDiffInSeconds,
} from 'legacyfrontend/utils/formatSecondsToHours';
const FlightScaleRow = (flight) => {
  const { arrival, arrivalDate, company, departure, departureDate, originDestinationReferences } =
    flight;

  const flightDuration = getTimeDiffInSeconds(departureDate, arrivalDate);

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        gap: '2rem',
        paddingLeft: '2rem',
      }}
    >
      <div className='vertical-dashed-line' />
      <Stack gap={3}>
        <Stack>
          <Stack alignItems='end' flexDirection='row' gap={1}>
            <Typography fontSize='1.1rem' fontWeight={800}>
              {formatTime(departureDate)}
            </Typography>
            <Typography bottom={1} fontSize='0.9rem' position='relative'>
              {formatDate(departureDate)}
            </Typography>
          </Stack>
          <Typography fontWeight={800}>{`${departure?.city}`}</Typography>
          <Typography fontSize='0.85rem' marginTop='4px'>
            {`${departure?.type === 'Airport' ? 'Aeropuerto' : ''} ${departure?.name}, ${
              departure?.country
            }`}
          </Typography>
        </Stack>

        <Stack flexDirection='row' gap={4}>
          <Stack>
            <Typography fontSize='18x' fontWeight={800}>
              {`Aerolínea: ${company}`}
            </Typography>
            <Typography fontSize='14px' fontWeight={400}>
              {`Duración: ${formatSecondsToHours(flightDuration)}`}
            </Typography>
          </Stack>
        </Stack>

        <Stack>
          <Stack alignItems='end' flexDirection='row' gap={1}>
            <Typography fontSize='1.1rem' fontWeight={800}>
              {formatTime(arrivalDate)}
            </Typography>
            <Typography bottom={1} fontSize='0.9rem' position='relative'>
              {formatDate(arrivalDate)}
            </Typography>
          </Stack>
          <Typography fontWeight={800}>
            {`${arrival?.city} (${originDestinationReferences})`}
          </Typography>
          <Typography fontSize='0.85rem' marginTop='4px'>
            {`${arrival?.type === 'Airport' ? 'Aeropuerto' : ''} ${arrival?.name}, ${
              arrival?.country
            }`}
          </Typography>
        </Stack>
      </Stack>
    </div>
  );
};

export default FlightScaleRow;
